import { Model, Factory } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'
import type { SchemaAttributes } from '../types.js'
import type { MockServer } from './server.js'

export type PermissionGroupData = SchemaAttributes<'PermissionGroup'>

export const model = Model as ModelDefinition<PermissionGroupData>

export const factory = Factory.extend<PermissionGroupData>({
  name(index: number) {
    return `Permission group ${index + 1}`
  },
})

export function routes(server: MockServer) {
  server.resource('permissionGroup', { path: '/permission_groups' })
}

export function seeds(server: MockServer) {
  server.create('permissionGroup', { name: 'Reception' })
  server.create('permissionGroup', { name: 'Nurse' })
  server.create('permissionGroup', { name: 'Student' })
  server.create('permissionGroup', { name: 'Administrator' })
}
